import RFIDReaderAdd from "@/pages/admin/hardware/devices/rfid/RFIDReaderAdd";

const RFIDReaderEdit = () => <RFIDReaderAdd mode="edit" />;

export default RFIDReaderEdit;
